import { render, staticRenderFns } from "./LicenseView.vue?vue&type=template&id=70d4adbb&"
import script from "./LicenseView.vue?vue&type=script&lang=js&"
export * from "./LicenseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports